import ClientCheckContainer from "../containers/ClientCheckContainer";

const ClientCheckPage = () => {
    return <ClientCheckContainer />;
};

export default ClientCheckPage;
